import { TripToMassive } from '../../../../../core';


export const tripsMassive = {
  export: false,
  sort: false,
  dialogHability: true,
  filter: false,
  paginator: true,
  exportFile: 'despacho_clientes.xlsx',
  disabled: false,
  partialField: '',
  paginatorAllData: true,
  columns: [
    {
      title: 'N° de viaje',
      name: 'tripId',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: TripToMassive) => element.tripId
    },
    {
      title: 'Viaje - Ruta',
      name: 'tripCode',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: TripToMassive) => element.tripCode
    },
    {
      title: 'Entidad de viaje',
      name: 'entityName',
      sort: true,
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: TripToMassive) => element.entityName
    }
  ]
};
